import { render, staticRenderFns } from "./QuestionCardTimer.vue?vue&type=template&id=84b149e4&"
import script from "./QuestionCardTimer.vue?vue&type=script&lang=js&"
export * from "./QuestionCardTimer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCardTimer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports